import * as React from "react";

interface GrozdLogoProps {
  size?: number;
  color?: string;
  className?: string;
}

export const GrozdLogo: React.FC<GrozdLogoProps> = ({
  size = 32,
  color = "currentColor",
  className,
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 200 240"
    width={size}
    height={size * 1.2}
    className={className}
    aria-label="Grozd logo"
  >
    <g
      transform="rotate(30,100,140)"
      fill="none"
      stroke={color}
      strokeWidth="5"
      strokeLinejoin="round"
      strokeLinecap="round"
    >
      <path d="M100 68Q114 48 132 40Q124 58 114 66Z" fill={color} />
      <line x1="100" y1="68" x2="118" y2="52" strokeWidth="3" />
      <circle cx="60" cy="100" r="22" />
      <circle cx="100" cy="100" r="22" />
      <circle cx="140" cy="100" r="22" />
      <circle cx="80" cy="140" r="22" />
      <circle cx="120" cy="140" r="22" />
      <circle cx="100" cy="180" r="22" />
    </g>
  </svg>
);
